import { Campaign } from '@/common/models';

import { ISharedPlanData, SharedPlanData } from './types/SharedPlanData';

interface ISharedPlanApiModel {
  jsonDataString: string;
  json_data_string?: string;
  campaigns?: Campaign[];
}

interface ISharedPlanCredentials {
  uuid: string;
  password: string;
}

class SharedPlan {
  private constructor(
    public password: string,
    public uuid: string,
  ) {}

  static fromObject(credentials: ISharedPlanCredentials) {
    return new SharedPlan(credentials.password, credentials.uuid);
  }

  public toApi(): ISharedPlanCredentials {
    return {
      uuid: this.uuid,
      password: this.password,
    };
  }

  static fromApi(apiObject: ISharedPlanApiModel): ISharedPlanData {
    const data = apiObject.json_data_string ?? apiObject.jsonDataString;
    const sharedPlanData = SharedPlanData.deserialize(data);
    sharedPlanData.campaign = apiObject.campaigns?.length ? apiObject?.campaigns[0] : null;
    return sharedPlanData;
  }
}

export default SharedPlan;
